import BaseQuestionModel from '../BaseQuestionModel'

import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  IConversationQuestionModelState,
  IConversationResponseValidation,
  ConversationQuestionModelTypes,
  ConversationSubmitResponse
} from './types'

const ConversationQuestionModel: IQuestionModelConstructor<ConversationQuestionModelTypes> = (
  questionSchema,
  action
) => {
  const { model } = BaseQuestionModel<ConversationQuestionModelTypes, IConversationQuestionModelState>({
    questionType: QuestionType.CONVERSATION,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IConversationQuestionModelState) {
  const submitAnswer: ArrayElementType<ConversationSubmitResponse> = { id: response.id }
  if (response.approve != null && !response.approve) submitAnswer.skip = 'terminate'
  if (response.skip) submitAnswer.skip = 'skip'
  return [submitAnswer]
}

function initState(state: IConversationQuestionModelState): IConversationQuestionModelState {
  state.response = { id: state.questionSchema.id }
  return state
}

function validateResponse({ questionSchema }: IConversationQuestionModelState): IConversationResponseValidation {
  return { valid: questionSchema.optional || false }
}

export default ConversationQuestionModel
